import React from "react";
// import { useSelector } from "react-redux";
// import { getMyTokenFill, myTokens } from "./court.data";
import TokenCube from "./TokenCube";

const CourtTokens = ({ tokens = [] }) => {
  // handleClickMyToken, highlightIndex, previewGame
  // return null;

  // const { totalCount } = useSelector(state => state.cart);
  // const { userTokens } = useSelector(state => state.sport)

  return(
    <>
      {/* {((totalCount && totalCount > 0) || (tokens?.length > 0)) && myTokens?.map((token, key) => (
        <TokenCube
          key={key}
          position={token.position}
          fill={getMyTokenFill(token.zoneCategory)}
          onClick={() => handleClickMyToken(token, key)}
          highlighted={previewGame && tokens?.length > 0 ? true : highlightIndex === key}
          totalCount={previewGame && tokens ? tokens?.length : totalCount} // TODO: replace accordingly
        />
      ))} */}

      {tokens?.map((token, key) => (
        <TokenCube
          key={key}
          position={token}
          // fill={getMyTokenFill(token.zoneCategory)}
          // onClick={() => handleClickMyToken(token, key)}
          // highlighted={previewGame && tokens?.length > 0 ? true : highlightIndex === key}
          // totalCount={previewGame && tokens ? tokens?.length : totalCount} // TODO: replace accordingly
        />
      ))}

      {/* {!previewGame && userTokens && userTokens?.length > 0 && purchasedTokens?.map((token, key) => (
        <TokenCube
          key={key}
          position={token.position}
          fill={getMyTokenFill(token.zoneCategory)}
          onClick={() => handleClickMyToken(token, key+1)}
          highlighted={highlightIndex === key+1}
          totalCount={userTokens?.length} // TODO: replace accordingly
        />
      ))} */}
    </>
  )
};

export default React.memo(CourtTokens);